import { View, Image } from "react-native";
import { SafeAreaView, type Edge } from "react-native-safe-area-context";

type Props = {
  children: React.ReactNode;
  overlay?: React.ReactNode;
  edges?: Edge[];
  transparent?: boolean;
};

export default function GlassScreenLayout({
  children,
  overlay,
  edges,
  transparent = false,
}: Props) {
  return (
    <View style={{ flex: 1, overflow: "hidden" }}>
      {!transparent && (
        <Image
          source={require("../assets/images/onboarding-bg.jpg")}
          style={{
            position: "absolute",
            width: "115%",
            height: "115%",
            left: "-7.5%",
            top: "-7.5%",
          }}
          resizeMode="cover"
        />
      )}
      <SafeAreaView style={{ flex: 1 }} edges={edges}>
        {children}
      </SafeAreaView>
      {overlay}
    </View>
  );
}
